import { arrayOf, shape, string } from 'prop-types'
import styled from 'styled-components'
import { Heading, HeadingSize, Paragraph } from '../Ui-Kits/Text'
import { Link } from '../Ui-Kits/Text/Link'

export const BannerithDescription = ({ title, links, description, ...props }) => {
  return (
    <Banner {...props}>
      {links && !!links?.length && (
        <Bredcrumb>
          {links.map(({ link, label }, index, list) => (
            <BreadcrunbItem key={index}>
              <Link
                color="black"
                to={link}
                bold
                underline={index !== list.length - 1}
                as={list.length === index + 1 ? 'span' : undefined}
              >
                {label}
              </Link>
            </BreadcrunbItem>
          ))}
        </Bredcrumb>
      )}
      <Content>
        <Heading size={HeadingSize.BIG} color="primary">
          {title}
        </Heading>
        <Paragraph color="primary">{description}</Paragraph>
      </Content>
    </Banner>
  )
}

BannerithDescription.propTypes = {
  title: string.isRequired,
  description: string,
  links: arrayOf(
    shape({
      link: string,
      label: string,
    })
  ),
}

const Banner = styled.div`
  padding: 1.5625rem 1rem;
  width: 100%;
`
const Content = styled.div`
  width: 100%;
  max-width: 792px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  flex-direction: column;
  margin: 0 auto;
`
const Bredcrumb = styled.ul`
  max-width: 1200px;
  margin: 0 auto;
`

const BreadcrunbItem = styled.li`
  display: inline;
  margin: 0;
  &:after {
    display: inline;
    content: ' / ';
  }
  &:last-child:after {
    display: none;
  }
`
